<template>
  <div
    :class="{ 'flex-column-reverse': smAndDown }"
    class="d-flex align-start px-4 px-md-8 pt-10 pb-14 ga-8"
  >
    <!-- KYC statuses -->
    <div class="pa-0 d-flex mt-5 mt-md-0 w-100" :style="`flex: 1 1 ${smAndDown ? '100%' : '50%'}`">
      <OnboardingTaskSummary
        :onboarding-actions="onboardingStore.draftMerchant?.onboardingActions"
        @onboarding-status-click="handleTaskClick"
      />
    </div>

    <!-- Order devices -->
    <div
      v-if="isOrderDevicesVisible"
      class="pt-sm-2 mt-md-8 d-flex flex-column justify-center w-100"
      :style="`flex: 1 1 ${smAndDown ? '100%' : '50%'}`"
    >
      <h3 class="mb-4">
        {{ t("onboarding.kyc_status.next_step.devices_order_title") }}
      </h3>
      <p class="mb-6">
        {{ t("onboarding.kyc_status.next_step.devices_order_subtitle") }}
      </p>
      <y-btn @click="handleOrderDevicesClick">
        {{
          t(
            `onboarding.kyc_status.next_step.devices_order_button_${isOrderDevicesStarted ? "continue" : "start"}`,
          )
        }}
      </y-btn>
    </div>

    <!-- Signup-->
    <div
      v-else-if="isSignupVisible"
      class="pt-sm-2 mt-md-8 d-flex flex-column justify-center w-100"
      :style="`flex: 1 1 ${smAndDown ? '100%' : '50%'}`"
    >
      <h3 class="mb-4">
        {{ t("onboarding.kyc_status.next_step.signup_title") }}
      </h3>
      <p class="mb-6">
        {{ t("onboarding.kyc_status.next_step.signup_subtitle") }}
      </p>
      <y-btn @click="handleSignUpClick">
        {{ t("onboarding.kyc_status.next_step.signup_button") }}
      </y-btn>
    </div>

    <!-- Signin -->
    <div
      v-else-if="isSigninVisible"
      class="pt-sm-2 mt-md-8 d-flex flex-column justify-center w-100"
      :style="`flex: 1 1 ${smAndDown ? '100%' : '50%'}`"
    >
      <h3 class="mb-4">
        {{ t("onboarding.kyc_status.next_step.signin_title") }}
      </h3>
      <p class="mb-6">
        {{ t("onboarding.kyc_status.next_step.signin_subtitle") }}
      </p>
      <y-btn @click="handleSignInClick">
        {{ t("onboarding.kyc_status.next_step.signin_button") }}
      </y-btn>
    </div>
  </div>
</template>

<script setup lang="ts">
import { DraftMerchantStatusEnum } from "@tableyeti/merchant-service";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useDisplay } from "vuetify";
import OnboardingTaskSummary from "./OnboardingTasksSummary.vue";
import { OnboardingFlowStatusEnum, useOnboardingStore } from "@/store/onboarding";

const { t } = useI18n();

const onboardingStore = useOnboardingStore();
const router = useRouter();

const isOrderDevicesStarted =
  onboardingStore.onboardingStatus === DraftMerchantStatusEnum.SiteAdded ||
  onboardingStore.onboardingStatus === DraftMerchantStatusEnum.SiteSubmittedError;

const isOrderDevicesVisible =
  onboardingStore.draftMerchant?.status === DraftMerchantStatusEnum.DetailsSubmitted ||
  isOrderDevicesStarted;

const isSignupVisible =
  onboardingStore.draftMerchant?.status === DraftMerchantStatusEnum.SiteSubmitted &&
  (!onboardingStore.draftMerchant?.isExistingUser ||
    onboardingStore.draftMerchant?.userStatus === "UNCONFIRMED");

//TODO(stefano-yeti): of all kyc status are true, but the status is pending. It means that our backend has not processed the kyc yet
//we can pull every x seconds to check if the status has changed
const isSigninVisible = onboardingStore.draftMerchant?.userStatus === "CONFIRMED";

const handleOrderDevicesClick = () => {
  onboardingStore.setStatusOverride(OnboardingFlowStatusEnum.SiteEdit);
};

const handleSignUpClick = () => {
  onboardingStore.setStatusOverride(OnboardingFlowStatusEnum.SignUp);
};

const handleSignInClick = () => {
  router.push("/signin");
  setTimeout(onboardingStore.clearDraftMerchant, 100);
};

const handleTaskClick = async (taskName: string) => {
  if (taskName === "contract") {
    handleKYCStatusClick();
    window.open(onboardingStore.draftMerchant?.dealSignUrl, "_self");
    return;
  }
  try {
    const merchantWithLink = await onboardingStore.submitDraftMerchant();
    if (merchantWithLink.hostedOnboardingLink) {
      window.open(merchantWithLink.hostedOnboardingLink, "_self");
    }
  } catch (error) {
    console.error("Failed get new hostedOnboardingLink", error);
    // TODO: handle error
  }
};

const handleKYCStatusClick = async () => {};

const { smAndDown } = useDisplay();
</script>
